import { render, staticRenderFns } from "./_EditTransportNoteDialog.vue?vue&type=template&id=95ddcec8&scoped=true&"
import script from "./_EditTransportNoteDialog.vue?vue&type=script&lang=js&"
export * from "./_EditTransportNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ddcec8",
  null
  
)

export default component.exports